import {
  GetRequest,
  PostRequest,
  PutRequest,
  DeleteRequest,
} from "./HttpService";

export const getBlogList = async () => {
  const data = await GetRequest("/Blog");
  return data;
};

export const createBlog = async (data) => {
  const formData = new FormData();
  formData.append("Title", data.Title);
  formData.append("Description", data.Description);
  formData.append("Abstract", data.Abstract);
  formData.append("AuthorId", data.AuthorId);
  if (data.Image) {
    formData.append("Image", data.Image);
  }

  const response = await PostRequest(
    "/Blog",
    formData,
    null,
    null,
    "multipart/form-data"
  );

  return response.data;
};

export const getBlogById = async (id) => {
  const data = await GetRequest("/Blog", encodeURIComponent(id));
  return data;
};

export const incrementBlogView = async (id) => {
  const response = await PostRequest("/Blog", {}, id, "view");
  return response.json();
};

export const editBlog = async (id, data) => {
  const formData = new FormData();
  formData.append("Title", data.Title);
  formData.append("Description", data.Description);
  formData.append("Abstract", data.Abstract);
  formData.append("AuthorId", data.AuthorId);
  if (data.Image) {
    formData.append("Image", data.Image);
  }

  const response = await PutRequest(
    "/Blog",
    formData,
    id,
    "multipart/form-data"
  );

  return response.data;
};

export const deleteBlogById = async (id) => {
  const response = await DeleteRequest("/Blog", id);
  return response.data;
};
